<div class="main-body">
  <app-select-group
    class="main-body"
    [itemList]="selectableList"
    [selectionMode]="SelectGroupMode.single"
    (itemChange)="onItemChange($event)"
  >
    <ng-template let-item>
      <img class="portrait-img" [ngClass]="item.isSelected ? 'is-selected' : ''" [src]="item.portraitUrl" />
    </ng-template>
  </app-select-group>
</div>
